<template>
  <el-form-item
    :label="label"
    class="exemption-rate"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="exemptionRate"
      type="text"
      :clearable="true"
      :maxlength="5"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '減免率'
    },
    prop: {
      type: String,
      default: 'exemption_rate'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '' : '例)1/2'
    }
  },
  computed: {
    exemptionRate: {
      get () {
        return this.value
      },
      set (exemptionRate) {
        this.$emit('input', exemptionRate)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorRegExp(this.label, '^[0-9]{1,2}/[0-9]{1,2}$', '分数', 'blur'))
          if (this.value) {
            rules.push(this.validatorFractionCheck(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-form-item {
  &.exemption-rate {
    .el-form-item__content {
        width: 12em;
    }
  }
}
</style>
